import * as structureType from "../../actiontype/StrutureType/StrutureType.jsx";
import { deleteReq, get, post, put } from "../../../../common/utils/index.js";
import { getByPharmacyId } from "../HospitalAction/Hospital.jsx";
import { getByRetailId } from "../RetailAction/Retail.jsx";

export const getStructuteList =
  (headers, showLoader, hideLoader, showToast, dataTrans) => (dispatch) => {
    showLoader();
    dispatch({ type: structureType.STRUCTURE_REQUEST_LIST });
    get("/HospitalFacility", headers)
      .then((res) => {
        dispatch({
          type: structureType.STRUCTURE_SUCCESS_LIST,
          payload: res?.data,
        });
        hideLoader();
      })
      .catch((err) => {
        hideLoader();
        dispatch({
          type: structureType.STRUCTURE_FAILURE_LIST,
          payload: err?.response?.data?.message,
        });
        showToast(
          "warn",
          "Attenzione",
          dataTrans(err?.response?.data?.message)
        );
      });
  };

  export const getByIdStructure = (id,showLoader,hideLoader,showToast,dataTrans) => (dispatch) => {
    showLoader();
  dispatch({ type: structureType.STRUCTURE_REQUEST_GETBYID });
  get(`/HospitalFacility/${id}`)
    .then((res) => {
      dispatch({
        type: structureType.STRUCTURE_SUCCESS_GETBYID,
        payload: res.data,
      });
      hideLoader();
      var headers = {
        pageNo: 1,
        pageSize: 10,
      }
      dispatch(getStructuteList(headers,showLoader,hideLoader))
    })
    .catch((err) => {
      dispatch({
        type: structureType.STRUCTURE_FAILURE_GETBYID,
        payload: err?.message,
      });
      showToast("warn","Attenzione",dataTrans(err?.response?.data?.message)
      );
    });
};


export const updateStructure = (id, payloadData, headers,showLoader,hideLoader,viewRoleId,showToast,t,) => (dispatch) => {
  showLoader();
dispatch({ type: structureType.STRUCTURE_REQUEST_UPDATE });
put(`/HospitalFacility/${id}`, payloadData.payload, headers)
  .then((res) => {
    dispatch({
      type: structureType.STRUCTURE_SUCCESS_UPDATE,
      payload: res.data,
    });
  
    hideLoader();
    payloadData?.setIsEditing(false)
    showToast("success",(res?.message))
    dispatch(getByIdStructure(viewRoleId,showLoader,hideLoader));
    // dispatch(getStructuteList(headers,showLoader,hideLoader));

  })
  .catch((err) => {
    hideLoader();
    dispatch({
      type: structureType.STRUCTURE_FAILURE_UPDATE,
      payload: err?.message,
    });

        showToast("warn",(err?.message))

  });
};

export const AddStructure = (AddStructureData,setIsSuccess,setIsModalOpen) => (dispatch) => {
  dispatch({ type: structureType.STRUCTURE_REQUEST_ADD });
  post(`/HospitalFacility/Contact`, AddStructureData.payload )
    .then((res) => {
      dispatch({
        type: structureType.STRUCTURE_SUCCESS_ADD,
        payload: res.data,
      });
      setIsSuccess(true);
      setIsModalOpen(true);
      AddStructureData.showToast('success',AddStructureData.t('text_toast_success'), res?.response?.data?.message)
      // showToast(
      //   "warn",
      //   "Attenzione",
      //   dataTrans(err?.response?.data?.message)
      // );
      // showToast('success', dataTrans('text_toast_success'), res?.response?.data?.message);
     
    if(AddStructureData?.structureFlag===true){
      dispatch(getByIdStructure(AddStructureData.HospitalID,AddStructureData.showLoader,AddStructureData.hideLoader,AddStructureData.showToast,AddStructureData.t))
    }else if(AddStructureData?.retailFlag===true){
      dispatch(getByRetailId(AddStructureData?.pharmacyID,AddStructureData?.showLoader,AddStructureData?.hideLoader,AddStructureData?.showToast,AddStructureData?.t))
    } 
    else if(AddStructureData?.structureFlag===false){
      dispatch(getByPharmacyId(AddStructureData.pharmacyID,AddStructureData.showLoader,AddStructureData.hideLoader,AddStructureData.showToast,AddStructureData.t))
    }    
    })
    .catch((err) => {
      // AddStructureData.hideLoader();
      dispatch({
        type: structureType.STRUCTURE_FAILURE_ADD,
        payload: err?.message,
      });
      AddStructureData.showToast("warn","Attenzione",AddStructureData.t(err?.response?.data?.message));
    });
};
// id, headers,showLoader,hideLoader,showToast,t,HospitalID
export const DeleteStructure = (AddStructureDataDelete) => (dispatch) => {
  dispatch({ type: structureType.STRUCTURE_REQUEST_DELETE });
  deleteReq(`/HospitalFacility/Contact/${AddStructureDataDelete.ID}`, AddStructureDataDelete.headers)
    .then((res) => {
      dispatch({
        type: structureType.STRUCTURE_SUCCESS_DELETE,
        payload: res.data,
      });
      if(AddStructureDataDelete?.structureFlag===true){
          dispatch(getByIdStructure(AddStructureDataDelete.HospitalID,AddStructureDataDelete.showLoader,AddStructureDataDelete.hideLoader,AddStructureDataDelete.showToast,AddStructureDataDelete.t))
        }else if(AddStructureDataDelete?.retailFlag===true){

          dispatch(getByRetailId(AddStructureDataDelete?.pharmacyID,AddStructureDataDelete?.showLoader,AddStructureDataDelete?.hideLoader,AddStructureDataDelete?.showToast,AddStructureDataDelete?.t))
        }
        else if(AddStructureDataDelete?.structureFlag===false){
          
          // console.log(`
          //   84587458458
          //   AddStructureDataDelete?.pharmacyID,===> ${AddStructureDataDelete}
          //   AddStructureDataDelete?.showLoader,===> ${AddStructureDataDelete?.showLoader}
          //   AddStructureDataDelete?.hideLoader,===> ${AddStructureDataDelete?.hideLoader}
          //   AddStructureDataDelete?.showToast,===> ${AddStructureDataDelete?.showToast}
          //   AddStructureDataDelete?.t===> ${AddStructureDataDelete?.t}
          //   `);
          

          dispatch(getByPharmacyId(AddStructureDataDelete?.pharmacyID,AddStructureDataDelete?.showLoader,AddStructureDataDelete?.hideLoader,AddStructureDataDelete?.showToast,AddStructureDataDelete?.t))
        }
    })
    .catch((err) => {
      dispatch({
        type: structureType.STRUCTURE_FAILURE_DELETE,
        payload: err?.message,
      });
    });
};

// CONTACT
// let AddStructureDataUpdate ={ID,payload,headers,showLoader,hideLoader,showToast,t,HospitalID}

export const updateStructureContact = (AddStructureDataUpdate,setIsModalOpen) => (dispatch) => {
  dispatch({ type: structureType.STRUCTURE_REQUEST_CONTACTUPDATE });
  put(`/HospitalFacility/Contact/${AddStructureDataUpdate.ID}`, AddStructureDataUpdate.payload, AddStructureDataUpdate.headers)
    .then((res) => {
      dispatch({
        type: structureType.STRUCTURE_SUCCESS_CONTACTUPDATE,
        payload: res.data,
      });
      AddStructureDataUpdate.showToast('success',res?.message);
      setIsModalOpen(false);
      if(AddStructureDataUpdate?.structureFlag===true){
      //   console.log("case111")
        dispatch(getByIdStructure(AddStructureDataUpdate.HospitalID,AddStructureDataUpdate.showLoader,AddStructureDataUpdate.hideLoader,AddStructureDataUpdate.showToast,AddStructureDataUpdate.t))
      }else if(AddStructureDataUpdate?.retailFlag===true){
        dispatch(getByRetailId(AddStructureDataUpdate?.pharmacyID,AddStructureDataUpdate?.showLoader,AddStructureDataUpdate?.hideLoader,AddStructureDataUpdate?.showToast,AddStructureDataUpdate?.t))
      }
      else{
        dispatch(getByPharmacyId(AddStructureDataUpdate?.pharmacyID,AddStructureDataUpdate?.showLoader,AddStructureDataUpdate?.hideLoader,AddStructureDataUpdate?.showToast,AddStructureDataUpdate?.t))
      }

    })
    .catch((err) => {
      AddStructureDataUpdate.showToast('warn',err?.message);
      dispatch({
        type: structureType.STRUCTURE_FAILURE_CONTACTUPDATE,
        payload: err?.message,
      });
    });
};



export const updateStatusStructure = (id, payload, header, showLoader, hideLoader, showToast,dataTrans) => (dispatch) => {

  showLoader();
  dispatch({ type: structureType.STRUCTURE_REQUEST_UPDATE })

  put(`/HospitalFacility/UpdateStatus/${id}`, payload, header)
    .then(res => {
      hideLoader();
      dispatch({ type: structureType.STRUCTURE_SUCCESS_UPDATE, payload: res.data })
      var headers = {
        pageNo: 1,
        pageSize: 10,
      }
      dispatch(getStructuteList(headers, showLoader, hideLoader));
      // dispatch(getByPatientId(id, showLoader, hideLoader))
      showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
    })
    .catch(err => {
      hideLoader();
      dispatch({ type: structureType.STRUCTURE_FAILURE_UPDATE, payload: err?.message })
      showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
    })
}

export const updatePrevId = (id) => (dispatch) => {
  dispatch({ type: structureType.STRUCTURE_PREV_ID, payload: id })
}